import React from 'react';
import {
    Typography,
    Avatar,
    withStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';

const DEFAULT_IMG =
  "https://s3.us-east-2.amazonaws.com/vgde-researchers-photos/placeholder-image-768x576.jpg";

const styles = theme => ({
    root : {
        marginTop : 24,
        display : "flex",
        margin  : 12,
        justifyContent : "left",
    },
    name : {
        fontFamily : "'Poppins', sans-serif",
        fontSize : 24,
    },
    textFont : {
        fontFamily : "'Poppins', sans-serif",
        fontSize   : 16,
    },
    textFontDesc : {
        fontFamily : "'Poppins', sans-serif",
        color : "black"
    },  
    large: {
        width: 200,
        height: 200,
    },
});

/**
 * Componente para renderizar información de los investigadores
 * Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0 
 */
const CardResearche = ({item, classes}) => {
    return(
        <div className={classes.root}>
            <Avatar alt="Remy Sharp" src={item.photo || DEFAULT_IMG} className={classes.large} />
            <div style={{margin : 12}}>
                <Typography 
                    className={classes.name} 
                    align="left" 
                    gutterBottom
                    display="block"
                >
                    {item.name}
                </Typography>
                <Typography 
                    variant="caption" 
                    className={classes.textFont} 
                    align="left" 
                    gutterBottom
                    display="block"
                >
                    {`- ${item.credentials}`}
                </Typography>
                {item.descriptions.map((des, key) => (
                    <Typography 
                        gutterBottom 
                        variant="caption" 
                        align="justify" 
                        className={classes.textFontDesc}
                        display="block"
                        key={key}
                    >
                        {`- ${des}`}
                    </Typography>
                ))}
            </div>
        </div>
    )
};

CardResearche.propTypes = {
    item    : PropTypes.object,
    classes : PropTypes.object,
}

export default withStyles(styles)(CardResearche);


// WEBPACK FOOTER //
// ./src/components/researchers/cardResearche.js